import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { useLocation } from "react-router-dom";
import React from "react";
import appColors from "../../theme/common/colors";
import useUIStore from "../../store/ui";
import { getSidebarItemsForUser } from "./config";
import { useAuth } from "../../store";
import { RoleTypes } from "../../../types";

const AppSidebar = React.memo(() => {
  // Use secure role validation instead of localStorage
  const getSecureRole = useAuth((state) => state.getSecureRole);
  const getCapabilities = useAuth((state) => state.getCapabilities);
  const user = useAuth((state) => state.user);

  const role = getSecureRole() as RoleTypes;
  const capabilities = getCapabilities();
  const advanceCapabilities = user.advanceCapabilities;

  // Get sidebar items based on role and capabilities
  const menuItems = getSidebarItemsForUser(
    role,
    capabilities,
    advanceCapabilities,
  );
  const isSidebarOpen = useUIStore((state) => state.isSidebarOpen);
  const location = useLocation();

  const renderMenuItems = (items: any, isSubmenu = false) => {
    return items.map((item: any, index: number) => {
      const isActive = location.pathname === item.path;
      const iconColor = isActive ? appColors.primary : "black";
      const icon = React.cloneElement(item.icon, {
        color: iconColor,
        fill: isActive ? appColors.primary : "none",
      });

      if (item.submenu) {
        return (
          <SubMenu
            key={index}
            label={
              <span className="flex items-center">
                {icon}
                {isSidebarOpen && (
                  <span className="ml-2 text-sm">{item.label}</span>
                )}
              </span>
            }
            style={{
              backgroundColor: isActive ? appColors.lightBlue : "white",
              borderRadius: 10,
              paddingLeft: isSubmenu ? 30 : 20,
            }}
          >
            {renderMenuItems(item.submenu, true)}
          </SubMenu>
        );
      }

      return (
        <MenuItem
          key={index}
          icon={icon}
          active={isActive}
          component={<Link to={item.path} />}
          style={{
            backgroundColor: isActive ? appColors.lightBlue : "white",
            borderRadius: 10,
            paddingLeft: isSubmenu ? 30 : 15,
          }}
        >
          <p
            className={` ${
              isActive ? "text-primary font-medium" : "text-black font-normal"
            } text-sm  line-clamp-2 w-[150px]`}
          >
            {item.label}
          </p>
        </MenuItem>
      );
    });
  };

  return (
    <Sidebar
      collapsed={!isSidebarOpen}
      className="px-2 py-3 bg-white flex flex-col h-full"
    >
      <Menu className="bg-white flex-grow">{renderMenuItems(menuItems)}</Menu>
    </Sidebar>
  );
});

export default AppSidebar;
